module.exports = __webpack_public_path__ + "static/media/boiraGebradora.c514722f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/boiraGebradora.svg
// module id = 825
// module chunks = 0